export default [
  {
    path: '/sku/code',
    name: 'sku_code',
    meta: {
      title: ''
    },
    component: () => import('views/sku/code')
  }
]